import { Box, Stack } from '@mui/material'
import LactationLogo from 'assets/LactationLogo'
import { useWidgetMilkingStats } from 'components/farm-dashboard/hooks/useWidgetMilkingStats'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { useGetMinutesFromSec } from 'utils/getMinutesFromSeconds/useGetMinutesFromSec'
import { BaseWidget } from '../baseWidget'

export const AvgConnectTime = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { data, isLoading } = useWidgetMilkingStats()
	const { morph, value: connectValue } = useGetMinutesFromSec(
		data?.stats?.connect_avg,
	)
	if (!permissions?.license_milking_process_check) return null
	return (
		<BaseWidget
			isLoading={isLoading}
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.blueBg,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<LactationLogo color={COLORS.blue} width={16} height={12} />
				</Box>
			}
			path={'/milking-process'}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' gap='4px' alignItems='center'>
					<TypographyPrimary16Bold>{connectValue}</TypographyPrimary16Bold>
					<TypographySecondary>мин</TypographySecondary>
				</Stack>
				<TypographyPrimary>Среднее время подключения</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
